import { PayloadAction } from "@reduxjs/toolkit";
import { ClientsState } from "../../models/ClientsState";
import { ImportClientsByVendorPayload } from "../../payload/ImportClientsByVendorPayload";

const importClientsByVendorFetch = (state: ClientsState, action: PayloadAction<ImportClientsByVendorPayload>) => {
    state.isLoading = true;
}

export default importClientsByVendorFetch;